module.exports = __webpack_public_path__ + "static/media/clinic-medical.1431d8d9.svg";